import CallMadeRoundedIcon from "@mui/icons-material/CallMadeRounded";
import { Box, Card, Link, Typography } from "@mui/material";
import useColors from "../../../api/hooks/useColors";
const DashboardCard = ({
  headline,
  subtitle,
  link,
  height = null,
  children,
  sx = {},
}) => {
  const colors = useColors();

  return (
    <Card
      sx={{
        boxShadow: `0px 0px 2px 1px ${colors.divider2}`,
        borderRadius: "10px",
        height: height ? height : "auto",
        ...sx,
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px",
        }}
      >
        {headline && (
          <Box>
            <Typography variant="subtitle1">{headline}</Typography>
            {subtitle && <Typography variant="caption">{subtitle}</Typography>}
          </Box>
        )}
        {link && (
          <Box
            sx={{
              position: "absolute",
              top: "18px",
              right: "16px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Link
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              underline="none"
              data-view-all-button="true"
              sx={{
                display: "flex",
                color: colors.common_black,
                alignItems: "center",
                cursor: "pointer",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              <Typography variant="caption" sx={{ marginRight: "8px" }}>
                View all
              </Typography>
              <CallMadeRoundedIcon sx={{ width: "18px", height: "16px" }} />
            </Link>
          </Box>
        )}
      </Box>
      {children}
    </Card>
  );
};

export default DashboardCard;
